/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An enumeration.
 * @export
 */
export const ClusterTypeEnum = {
    Empty: '',
    Batch: 'batch',
    Function: 'function',
    Notebook: 'notebook',
    PrefectServe: 'prefect/serve',
    PrefectWorker: 'prefect/worker',
    RunCli: 'run/cli'
} as const;
export type ClusterTypeEnum = typeof ClusterTypeEnum[keyof typeof ClusterTypeEnum];


export function ClusterTypeEnumFromJSON(json: any): ClusterTypeEnum {
    return ClusterTypeEnumFromJSONTyped(json, false);
}

export function ClusterTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterTypeEnum {
    return json as ClusterTypeEnum;
}

export function ClusterTypeEnumToJSON(value?: ClusterTypeEnum | null): any {
    return value as any;
}

